import { type ReactNode } from 'react';
import cn from 'classnames';
import { HStack } from '@direct-frontend/components';
import styles from './AdvBannerStrip.module.css';

type AdvBannerStripProps = {
    children: ReactNode;
    type?: 'dark-blue';
};

export const AdvBannerStrip = ({ children, type }: AdvBannerStripProps) => (
    <HStack
        alignItems="center"
        gap="12"
        className={cn(styles.banner, {
            [styles.darkBlue]: type === 'dark-blue',
        })}
    >
        {children}
    </HStack>
);
